import { createBrowserRouter } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';


const router = createBrowserRouter([LoginRoutes,MainRoutes], {
    future: {
        v7_startTransition:true,
        v7_relativeSplatPath:true, 
        v7_skipActionErrorRevalidation:true,
        v7_partialHydration:true,
        v7_skipActionErrorRevalidation:true,
        v7_partialHydration:true,
        v7_normalizeFormMethod:true,
        v7_fetcherPersist:true
    }});

export default router;